import React from 'react';
import { type TableColumn } from 'src/shared/components/Table/Table/types';
import get from 'lodash/get';
import { TableCell as MUITableCell } from '@mui/material';

type TableCellProps<T> = {
  row: T;
  column: TableColumn<T>;
  index: number;
};

export const TableCell = <T,>({ row, column, index }: TableCellProps<T>) => {
  const getContent = () => {
    if (column.renderCell) {
      return column.renderCell(row, index);
    }
    return get(row, column.accessor);
  };

  const getTableCellProps = () => {
    if (column.getTableCellProps) {
      return column.getTableCellProps(row);
    }
    return undefined;
  };

  return <MUITableCell {...getTableCellProps()}>{getContent()}</MUITableCell>;
};
